import createAPI from '../axios'

// 资源申请模板管理 API
const creditManage = {
    //学生学分
    stuCredit: {
        initData: config => createAPI('/creditManage/stuCredit/initData', 'post', config),

        queryList: config => createAPI('/creditManage/stuCredit/queryList', 'post', config),

        loadDetail: config => createAPI('/creditManage/stuCredit/loadDetail', 'post', config),

        exportFile: config => createAPI('/creditManage/stuCredit/exportFile', 'post', config),
    },
    //专业学分
    majorCredit: {
        initData: config => createAPI('/creditManage/majorCredit/initData', 'post', config),

        queryList: config => createAPI('/creditManage/majorCredit/queryList', 'post', config),

        exportFile: config => createAPI('/creditManage/majorCredit/exportFile', 'post', config),

        queryDetailList: config => createAPI('/creditManage/majorCredit/queryDetailList', 'post', config),
    },
};

export default creditManage;



// WEBPACK FOOTER //
// ./src/api/modules/creditManage.js